<template>
  <div>
    <label class="d-flex fs-14 font-mont fw-500 color-darkblack mb-1">
      {{ label }}<span v-show="isMandatory" class="asterik">*</span>
    </label>
    <div
      class="position-relative single-select"
      :class="{ 'not-selected': !selectedOption }"
      ref="dropdownWrapper"
    >
      <b-skeleton v-if="showLoader" height="38px"></b-skeleton>

      <template v-else>
        <!-- Showing selected option or placeholder text -->
        <div
          class="selected-option text-capitalize"
          @click="disabled ? '' : toggleDropdown()"
          :class="{
            error: error,
            pointer: !disabled,
            'cursor-not-allowed disabled-field': disabled,
          }"
        >
          {{ selectedLabel }}
          <img
            class="down-arrow"
            :class="!isDropdownOpen ? 'pl-3' : 'up-arrow-rotate'"
            src="@/assets/images/common/down-arrow-sm.svg"
          />
        </div>

        <!-- Options list -->
        <div
          v-show="isDropdownOpen"
          class="selectCustom-dropdown position-absolute"
        >
          <b-form-group>
            <b-form-radio-group
              v-model="selectedOption"
              :options="optionsArray"
              :disabled="disabled"
              value-field="key"
              text-field="label"
              @change="selectOption"
              buttons
              stacked
              :class="{
                'error-border': error,
              }"
            />
          </b-form-group>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "SingleSelect",
  props: {
    showLoader: {
      type: Boolean,
      default: false,
    },
    optionsArray: {
      type: Array,
      required: true,
    },
    text: {
      type: String,
      default: "Label",
    },
    isMandatory: {
      type: Boolean,
      default: true,
    },
    error: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    noHide: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      required: false,
    },
    vmodel: {
      type: String,
    },
    placeholder: {
      type: String,
      default: "Enter",
    },
    label: {
      type: String,
      default: "Label",
    },
  },
  data() {
    return {
      selectedOption: this.vmodel || "private",
      isDropdownOpen: false,
    };
  },
  watch: {
    vmodel: {
      handler(newValue) {
        this.selectedOption = newValue;
      },
      immediate: true,
    },
  },
  methods: {
    toggleDropdown() {
      if (this.disabled) return;
      this.isDropdownOpen = !this.isDropdownOpen;
    },
    selectOption() {
      console.log("Selected value:", this.selectedOption);
      this.$emit("select-value", this.selectedOption);
      this.isDropdownOpen = false;
    },
    handleClickOutside(event) {
      const wrapper = this.$refs.dropdownWrapper;
      if (wrapper && !wrapper.contains(event.target)) {
        this.isDropdownOpen = false;
      }
    },
  },
  computed: {
    selectedLabel() {
      const selected = this.optionsArray.find(
        (option) => option.key === this.selectedOption,
      );
      return selected ? selected.label : "Select";
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },
};
</script>

<style>
.single-select {
  position: relative;
}

.selected-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* cursor: pointer; */
  padding: 10px 14px;
  background: #ffffff;
  border: 1px solid #d0d5dd;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  height: 37px;
  line-height: 1.5;
}
.selectCustom-dropdown .btn-group-vertical {
  width: 100%;
}
.selectCustom-dropdown .btn-secondary {
  background-color: #f9f9f9;
  border-color: #f9f9f9;
  text-align: justify;
  color: #333;
  font-weight: 600;
  font-family: Lato, sans-serif;
  border: none;
  text-align: left;
  font-size: 11px;
  padding: 10px;
}
.selectCustom-dropdown
  .btns-stckd
  .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #333 !important;
  border-color: unset !important;
  background-color: #c8d9e5 !important;
  font-weight: 600 !important;
}
.selectCustom-dropdown .btn-secondary:not(:disabled):not(.disabled):active,
.btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #333 !important;
  border-color: unset !important;
  background-color: #c8d9e5 !important;
  font-weight: 600 !important;
}
.selectCustom-dropdown .btn-secondary:hover {
  background-color: #e8eff4;
}
.selectCustom-dropdown .form-group {
  margin-bottom: 0;
}
.selected-option img {
  transition: transform 0.3s ease;
}
.selectCustom-dropdown {
  border: 1px solid rgba(41, 136, 230, 0.2196078431372549);
  box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.4);
  min-height: auto;
  max-height: 150px;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  border-radius: 4px;
  z-index: 22;
  background: #fff;
}

.up-arrow-rotate {
  transform: rotate(180deg);
}

.error-border {
  border: 1px solid red;
}
</style>
